import { useEffect, useRef } from 'react';

function Popover({ children, content, show, setShow, trigger = 'click' }) {
	const wrapperRef = useRef(null);

	const handleMouseOver = () => {
		if (trigger === 'hover') {
			setShow(true);
		}
	};

	const handleMouseLeft = () => {
		if (trigger === 'hover') {
			setShow(false);
		}
	};

	useEffect(() => {
		function handleClickOutside(event) {
			if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
				setShow(false);
			}
		}

		if (show) {
			// Bind the event listener
			document.addEventListener('mousedown', handleClickOutside);
			return () => {
				// Unbind the event listener on clean up
				document.removeEventListener('mousedown', handleClickOutside);
			};
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [show, wrapperRef]);

	return (
		<div ref={wrapperRef} onMouseEnter={handleMouseOver} onMouseLeave={handleMouseLeft} className='min-w-6 relative flex justify-center'>
			<div onClick={() => setShow(!show)}>{children}</div>
			<div hidden={!show} className='absolute top-full right-0 z-[1000] transition-all'>
				{content}
			</div>
		</div>
	);
}

export default Popover;
